import { useRef, useState, useEffect } from "react";

const hasIntersectionObserver = typeof IntersectionObserver !== "undefined";

/**
 * @param {{ onVisible: () => void, onInvisible: () => void }} callbacks
 * @returns {(node: Element | null) => void} a ref for the observed element
 */
const useIsInView = ({ onVisible, onInvisible }) => {
  const [node, setNode] = useState(/** @type {Element | null} */ (null));
  const cbRef = useRef({ onVisible, onInvisible });
  useEffect(() => {
    cbRef.current = { onVisible, onInvisible };
  });

  useEffect(() => {
    if (!node) return undefined;
    if (!hasIntersectionObserver) return cbRef.current.onVisible();

    const handleIntersect = ([event]) => {
      if (event.isIntersecting) {
        cbRef.current.onVisible();
      } else {
        cbRef.current.onInvisible();
      }
    };

    const options = { root: null, threshold: 1 };
    const observer = new IntersectionObserver(handleIntersect, options);
    observer.observe(node);
    return () => {
      observer.disconnect();
    };
  }, [node]);

  return setNode;
};

export default useIsInView;
